<template>

<div class="pt-12">
    <div class="relative">
        <div class="bg-black">
            <img :style="'opacity: ' + ( opacity ? opacity : '.35' ) + ';'" style="max-height: 500px;" draggable="false" class="object-cover w-full" :src="img">
        </div>

            <div style="position: absolute; w-full; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 100%;"
                    class="align-middle text-center text-white overflow-hidden pt-10 sm:pt-0">
                <h3 class="text-gray-300 text-base sm:text-lg  md:text-2xl lg:text-3xl xl:text-4xl font-thin"><span v-html="intro"></span></h3>
                <h1 class="              text-xl   sm:text-3xl md:text-3xl lg:text-4xl xl:text-5xl font-semibold"><span v-html="title"></span></h1>
                <h3 class="text-gray-200 text-base sm:text-lg  md:text-2xl lg:text-3xl xl:text-4xl font-thin"><span v-html="below1"></span></h3>
                <h3 class="text-gray-200 text-base sm:text-lg  md:text-2xl lg:text-3xl xl:text-4xl font-thin"><span v-html="below2"></span></h3>
        </div>
    </div>
</div>

</template>

<script>
export default {
    props: [ 'img', 'intro', 'title', 'below1', 'below2', 'opacity' ],
}
</script>
